module.exports = __webpack_public_path__ + "static/media/freedom.08cfb728.png";